<template>
  <div class="ViewLKPassportIndex">
    <div style="display: flex; align-items: center;">
      <v-spacer />

      <v-btn @click.stop="onOpenDownloadModal">
        Скачать данные
      </v-btn>
    </div>

    <v-row dense>
      <v-col md :sm="12">
        <Stats
          @select="selectItems"
        />
      </v-col>
      <v-col md :sm="12">
        <MainContent
          ref="mainContent"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// Components.
import Stats from './components/Statistics/Stats.vue'
import MainContent from './components/Statistics/MainContent.vue'

// Utils
import { createPassportReportModal } from '@/views/PassportsList/utils'
import { LKPassportMapper as StoreMapper } from '@/views/LKPassport/store'

export default {
  name: 'LKPassportIndex',
  components: { Stats, MainContent },
  computed: {
    ...StoreMapper.mapState(['filters']),
  },
  methods: {
    selectItems(filters) {
      this.$refs.mainContent.$refs.filters.setFilters(filters)
    },
    async onOpenDownloadModal() {
      const propsData = {
        params: { isList: true },
        requestParams: this.filters,
        title: 'Отчет',
      }
      const modal = await createPassportReportModal(this, propsData)
      await modal.open()
    },
  },
}
</script>

<style lang="scss">
.ViewLKPassportIndex {
  padding: 40px;
  background-color: $webflow-color-white;
}
</style>
